const Taiko = ({ width = '24', height = '24', className, ...rest }) => {
  return (
    <svg
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      className={className}
      width={width}
      height={height}
      {...rest}
    >
      <circle
        cx="11.7148"
        cy="12"
        r="11.25"
        fill="white"
        stroke="#CBCBCB"
        strokeWidth="0.5"
      />
      <path
        d="M5.94388 10.8666H5.01279V14.0421H4.2346V10.8666H3.30078V10.1484H5.94388V10.8666Z"
        fill="#2F2F2F"
      />
      <path
        d="M7.2222 13.1356L6.89454 14.0394H6.07812L7.53074 10.1484H8.44818L9.9008 14.0394H9.07892L8.75672 13.1356H7.2222ZM7.98673 10.9785L7.4734 12.4147H8.50006L7.98673 10.9785Z"
        fill="#2F2F2F"
      />
      <path
        d="M11.3848 14.0421H10.6094V10.1484H11.3848V14.0421Z"
        fill="#2F2F2F"
      />
      <path
        d="M15.6463 14.0421H14.7234L13.6148 12.3683L13.2872 12.7233V14.0421H12.5117V10.1484H13.2872V11.6666L14.6934 10.1484H15.6791L14.1445 11.8004L15.6463 14.0421Z"
        fill="#2F2F2F"
      />
      <path
        d="M20.0871 12.0983C20.0871 13.2068 19.1587 14.1352 18.0393 14.1352C16.8952 14.1352 15.9805 13.2178 15.9805 12.071C15.9805 10.987 16.9252 10.0586 18.0338 10.0586C19.1615 10.0559 20.0871 10.9788 20.0871 12.0983ZM16.7668 12.1147C16.7668 12.8137 17.3457 13.4034 18.0338 13.4034C18.7273 13.4034 19.3007 12.8137 19.3007 12.0955C19.3007 11.361 18.7355 10.7822 18.0283 10.7822C17.3211 10.7849 16.7668 11.3747 16.7668 12.1147Z"
        fill="#2F2F2F"
      />
    </svg>
  );
};

export default Taiko;
